module.exports = __webpack_public_path__ + "static/media/coach.19a2bd3d.svg";